module.exports = __webpack_public_path__ + "img/antes_despues_214.27c29c5c.png";